import { createRouter, createWebHashHistory, RouteRecordRaw } from 'vue-router'
import HomeView from '../views/HomeView.vue'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'search',
    component: () => import(/* webpackChunkName: "search" */ '../views/SearchView.vue')
  },
  {
    path: '/about',
    name: 'about',
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  },
  {
    path: "/map",
    name: "view-map",
    component: () => import(/* webpackChunkName: "view-pdf" */ '../views/MapView.vue'),
    props: true
  },
  {
    path: "/map/:place",
    name: "view-map-place",
    component: () => import(/* webpackChunkName: "view-pdf" */ '../views/MapView.vue'),
  },
  {
    path: "/view-pdf/:meeting_id",
    name: "view-pdf",
    component: () => import(/* webpackChunkName: "view-pdf" */ '../views/PdfView.vue'),
    props: true
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
